$(document).ready(function () {
    if($('.welleasy-homepage-brands-slider').length > 0){
        $('.welleasy-homepage-brands-slider').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 2,
            autoplay: true,
            dots: false,
            slideTransition: 'linear',
            autoplayTimeout: 3000,
            autoplaySpeed: 0,
            speed: 5000,
            loop: 'loop',
            cssEase: 'linear',
            arrows: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    }


    if($('.product_slider').length > 0){
        $('.product_slider').slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: false,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.brand_slider').length > 0){
        $('.brand_slider').slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.welleasy-testimonial-slider').length > 0){
        $('.welleasy-testimonial-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 940,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.membership-work-slider').length > 0){
      console.log( "///////////////////////////////////////// CUSTOMER JS Running" )
        $('.membership-work-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 940,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.diet_slider').length > 0){
        $('.diet_slider').slick({
            slidesToShow: 6,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                }

            ]
        });
    }

    var filtered = false;

    $('.js-filter').on('click', function () {
        if (filtered === false) {
            $('.diet_slider').slick('slickFilter', ':even');
            $(this).text('Unfilter Slides');
            filtered = true;
        } else {
            $('.diet_slider').slick('slickUnfilter');
            $(this).text('Filter Slides');
            filtered = false;
        }
    });

    if ($('.refer-popup-HTML').length > 0){
        if (!localStorage.getItem("referFriendPopup")){
            var referPopupHTML = $('.referFriend-popup').html();
            localStorage.setItem("referFriendPopup", referPopupHTML);
            $('.refer-popup-HTML').html(localStorage.getItem("referFriendPopup"));
            $(".refer-popup-HTML .modal_popup").addClass("show-modal");
        }
    }
    var closeButton = document.querySelector(".close-button");
    if(closeButton){
        closeButton.addEventListener("click", function(){
            $(".refer-popup-HTML .modal_popup").removeClass("show-modal");
        });
    }
    $(document).mouseup(function (e) {
        let selectedBody = $(".modal-content");
        if (!selectedBody.is(e.target) && selectedBody.has(e.target).length === 0) {
            $("body").removeClass("modal-popup_open");
            $(".modal_popup.show-modal").removeClass("show-modal");
        }
    });
});

function HandleFormButtons( form, response, type )
{
    HandleFormButtonDisplay( form, type );
    HandleFormQty( form, response );
}

function HandleFormQty( form, response )
{
    var qtyInput = form.elements.quantity;

    if( qtyInput )
    {
        var quantityValue = 1;
        if( response.quantity )
        {
            quantityValue = response.quantity;
        }
        qtyInput.value  = quantityValue;
    }
}


function HandleFormButtonDisplay( form, type )
{
    return;
    
    var parent    = SearchParentsFor( form, "product-row-qty-buy-button" );
    var qtyCol    = parent.querySelector( ".product-quantity-col" );
    var buttonCol = parent.querySelector( ".product-buy-button-col" );
    var qtyColAutoship = parent.querySelector( ".product-quantity-col-autoship" );
    var buttonColAutoship = parent.querySelector( ".product-buy-button-col-autoship" );


    if( type == "show" )
    {
        buttonCol.classList.add( "hidden" );
        qtyCol.classList.remove( "hidden" );
        qtyCol.classList.add( "product-quantity-col-full" );
        qtyCol.querySelector( "quantity-input" ).setAttribute( "data-item-in-cart", "true" );
        // buttonColAutoship.classList.add( "hidden" );
        // qtyColAutoship.classList.remove( "hidden" );
        // qtyColAutoship.classList.add( "product-quantity-col-full" );
        // qtyColAutoship.querySelector( "quantity-input" ).setAttribute( "data-item-in-cart", "true" );
    }
    else
    {
      buttonCol.classList.remove( "hidden" );
      qtyCol.classList.add( "hidden" );
      qtyCol.classList.remove( "product-quantity-col-full" );
  
      qtyCol.querySelector( "quantity-input" ).setAttribute( "data-item-in-cart", "false" );
    }
}

function HandleFormV2Buttons( cart )
{
    var forms = document.querySelectorAll("product-form:not(.product-autoship)");
    forms.forEach( function( form )
    {
        var formVariant = form.querySelector( ".product-variant-id" );
        var cartItem = cart;

        var itemInCart = false;
        cart.items.forEach( function( item )
        {
            if( item.id == formVariant.value )
            {
                itemInCart = true;   
                cartItem = item;
            }
        } );

        if( !itemInCart )
        {
            HandleFormButtons( form.form, cartItem, "hide" );
        }
        else
        {
            HandleFormButtons( form.form, cartItem, "show" );
        }
    } );
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// product page with recharge subscriptions and variants
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


function SetQuantitySelectorState( )
{
    var spidTag = document.querySelector( "form[action='/cart/add'] input[name='selling_plan']" );
    var vid   = document.querySelector( "form[action='/cart/add'] input[name='id']" ).value;
    var items = document.querySelectorAll( "#CartDrawer .cart-drawer-items .we_cart_item" );
    var hit   = false;
    var qty   = 0;
    var spid  = "";

    if ( spidTag )
    {
        spid = spidTag.value;
    }

    for ( var i = 0; i < items.length; i++ )
    {
        var itemVID = items[ i ].getAttribute( "data-variant-id" );

        if ( itemVID == vid )
        {
            var itemSPID = items[ i ].getAttribute( "data-selling-plan-id" );
            if ( spid == "" )
            {
                if ( itemSPID == undefined )
                {
                    hit = true;
                    qty = Number( items[ i ].getAttribute( "data-cart-item-quantity" ) );
                    break;
                }
            }
            else if ( spid == itemSPID )
            {
                hit = true;
                qty = Number( items[ i ].getAttribute( "data-cart-item-quantity" ) );
                break;
            }
        }
    }

    var buyButton   = document.querySelector( ".product-buy-button-col" );
    var qtyCol      = document.querySelector( ".product-quantity-col" );
    var qtySelector = buyButton.closest( ".product-row-qty-buy-button" ).querySelector( "quantity-input" );
    var form        = buyButton.querySelector( "form.ajax-product-form" );
    if ( hit )
    {
        buyButton.classList.add( "hidden" );
        qtyCol.classList.remove( "hidden" );
        qtySelector.setAttribute( "data-item-in-cart", "true" );
        qtySelector.querySelector( "input[name='quantity']" ).value = qty;
    }
    else
    {
        buyButton.classList.remove( "hidden" );
        qtyCol.classList.add( "hidden" );
        qtySelector.setAttribute( "data-item-in-cart", "false" );
        qtySelector.querySelector( "input[name='quantity']" ).value = 1;
        form.removeAttribute( "disabled" );
        form.classList.remove( "disabled" );
    }
}


// move the selling plans into the <label> for the subscription option, to make the styling easier
// and also insert all the custom fields that recharge doesn't support

// the recharge widget deletes some of the extra dom elements that get injected below (needed to meet the styling)
// so add them back in when needed...
function ObserveWidget( widget )
{
    console.log( "observing widget" );

    var debounceTimer;
    var wrapper = widget.parentNode;
    var observer = new MutationObserver( function( ml, o )
    {
        if ( debounceTimer )
        {
            clearTimeout( debounceTimer );
        }
        debounceTimer = setTimeout( function( )
        {
            debounceTimer = undefined;
            observer.takeRecords( );
            observer.disconnect( );

            const start   = new Date( ).getTime( );
            const encoder = new TextEncoder();
            const data = encoder.encode( document.body.innerHTML.toString( ) );

            // potemntial timing issue here, as any important changes that happen whilst the hash is being
            // copmuted won't trigger the observer code... but this check is added to prevent async death loops
            // where something else triggers a dom change that cascades to the ui thread doing nothing but rebuilding
            // the dom, so having a stale dom seems fasirly unlikely
            crypto.subtle.digest( "SHA-256", data ).then( function( digest )
            {
                const hashArray = Array.from( new Uint8Array( digest ) );
                const hashStr   = hashArray.map( ( b ) => b.toString( 16 ).padStart( 2, "0" ) ).join( "" );
                const end       = new Date( ).getTime( );

                if ( hashStr != wrapper._observer_markup_hash )
                {
                    wrapper._observer_markup_hash = hashStr;

                    ShowCustomSubscriptionWidget( observer );
                    SetQuantitySelectorState( );
                }

                observer.observe( wrapper, { "childList": true, "subtree" : true } );
            } );
            
        }, 100 );
    } );
    observer.observe( wrapper, { "childList": true, "subtree" : true } );
}

function ActiveCurrencyString( val )
{
    var locale = "en-GB";
    return ( new Intl.NumberFormat( locale, { style: 'currency', currency: Shopify.currency.active } ).format( val ) );
}
function ParsePrice( txt )
{
    var i = 0;
    while ( i < txt.length )
    {
        if ( ( txt.charAt( i ) >= '0' ) && ( txt.charAt( i ) <= '9' ) )
        {
            break;
        }
        i++;
    }
    var parse = txt.substr( i );
    return parseFloat( parse );
}

function JustUpdateThePricing( )
{
    var vid   = document.querySelector( "input[name='id']" ).value;
    var price = Number( g_productDetail.variants[ vid ].price ) / 100;
    
    var priceElement = document.querySelector(".component-product-price.price-large");
    if (priceElement && price !== undefined && price !== null && price !== "") {
        priceElement.innerHTML = ActiveCurrencyString(price);
    }

    var cap = Number( g_productDetail.variants[ vid ].compare_price ) / 100;
    var comparePriceElement = document.querySelector( ".component-product-compare-price-amount" );
    if (comparePriceElement) {
        comparePriceElement.innerHTML = ActiveCurrencyString( cap );
    }

    var pc = ((cap - price) * 100) / cap;
    var percentageElement = document.querySelector(".component-product-price-percentage");
    if (percentageElement) {
        percentageElement.innerHTML = "-" + pc.toFixed(0) + "%";
    }
}

function ShowCustomSubscriptionWidget( observer )
{
    if ( g_liquidLookup.autoship_enabled )
    {
        ReallyShowCustomSubscriptionWidget( observer );
    }
    else
    {
        JustUpdateThePricing( );
    }
}

function UpdateRechargeWidget( widget, custom )
{
    /* 
        This function ReallyShowCustomSubscriptionWidget is full off horrible DOM changing script..
        ideally, the below needs to be implemented for the rest of the widget and not just updating the one time selector.
        Maybe one for the future
    */
    var labels = custom.querySelectorAll( "label" );  


    var currentProduct          = window.Shopify.current_product.id;
    //var currentProductVariant   = window.Shopify.current_product.current_variant.id; //Annoyingly this doesn't update when variant pills are selected, wtf?
    var currentProductVariant   = document.querySelector( "form[action='/cart/add'] input[name='id']" ).value;
    var recharge                = window.Recharge;
    if( recharge )
    {
        var widgetData = recharge.widgets[ currentProduct ];
        if( widgetData )
        {
            var widgetDataProduct   = widgetData.product
            var plans               = widgetData.product.plans;
            if( plans && plans.length )
            {
                var labels = custom.querySelectorAll( "label" );
                labels.forEach( function( label )
                {
                    var planInput       = label.querySelector( "input" );
                    var planInputValue  = planInput.getAttribute( "value" );
                    var planData        = {};

                    var target      = label.querySelector( ".rc-radio__label" );
                    
                    plans.forEach( function( plan )
                    {
                        if( plan.type == planInputValue )
                        {
                            planData = plan;
                        }
                    } );

                    var widgetDataVariantPlan = {};
                    widgetDataProduct.variants.forEach( function( widgetDataVariant )
                    {
                        if( widgetDataVariant.external_variant_id == currentProductVariant )
                        {
                            var widgetDataVariantPlanPrices = widgetDataVariant.prices[ 0 ].plans;
                            widgetDataVariantPlanPrices.forEach( function( widgetDataVariantPlanPriceData )
                            {
                                if( widgetDataVariantPlanPriceData.id == planData.id )
                                {
                                    widgetDataVariantPlan = widgetDataVariantPlanPriceData;
                                }
                            } );
                        }
                    } );

                    if( planData.type == "onetime" )
                    {
                        target.innerText        = "";
                        var planTitleWrapperEl  = document.createElement( "span" );
                        planTitleWrapperEl.setAttribute( "class", "rc-widget-title-wrapper" );

                        var planTitleEl         = document.createElement( "span" );
                        planTitleEl.innerText   = widgetData.widgetSettings.onetime_message;
                        planTitleEl.setAttribute( "class", "rc-widget-title" );

                        var planPriceEl         = document.createElement( "span" );
                        planPriceEl.innerText   = ActiveCurrencyString( widgetDataVariantPlan.discounted_price );
                        planPriceEl.setAttribute( "class", "rc-widget-price-el" );

                        planTitleWrapperEl.appendChild( planTitleEl );
                        planTitleWrapperEl.appendChild( planPriceEl );

                        target.appendChild( planTitleWrapperEl );
                    }
                } );
            }
        }
    }
}

function ReallyShowCustomSubscriptionWidget( observer )
{
    var widget = document.querySelector( ".shopify-app-block.recharge-subscription-widget" );
    var plans  = widget.querySelector( ".rc-selling-plans" );
    var main   = document.querySelector( ".product-main" );
    var custom = document.querySelector( ".custom-recharge-subscription-widget" );

    if ( custom )
    {
        custom.remove( );
    }
    custom = widget.cloneNode( true );

    UpdateRechargeWidget( widget, custom );

    var customPlans = custom.querySelector( ".rc-selling-plans" );

    if ( !customPlans )
    {
        customPlans = document.createElement( "div" );
        customPlans.classList.add( "rc-selling-plans" );
        customPlans.innerHTML =
        `
            <span class="rc-selling-plans-single" data-v-ac513cdf="">Delivers every 4 Weeks</span>
        `;
    }

    var leftBlock = document.createElement( "div" );
    leftBlock.setAttribute( "class", "custom-subscription-left-block" );
    leftBlock.appendChild( custom.querySelector( ".rc-subscription-details button.rc-subscription-details__button" ) );
    custom.querySelector( ".rc-subscription-details" ).appendChild( leftBlock );

    //custom.querySelector( ".subscription-radio" ).appendChild( customPlans );
    //customPlans.insertBefore( custom.querySelector( ".subscription-radio .rc-radio__price" ), customPlans.firstChild );
    custom.querySelector( ".rc-subscription-details" ).appendChild( customPlans );
    
    //custom.querySelector( ".subscription-radio .rc-radio__subscription" ).innerHTML = main.getAttribute( "data-sub-title" );
    custom.querySelector( ".subscription-radio .rc-radio__subscription" ).innerHTML = widget.querySelector( ".rc-radio__subscription" ).innerHTML;

    var sub = custom.querySelector( ".rc-radio__subscription" );
    var sp  = document.createElement( "div" );

    sp.setAttribute( "class", "rc-option-title-text" );

    var planTitleWrapperEl  = document.createElement( "span" );
    planTitleWrapperEl.setAttribute( "class", "rc-widget-title-wrapper" );

    var planTitleIcon = document.createElement( "img" );
    planTitleIcon.setAttribute( "src", main.getAttribute( "data-sub-icon" ) );

    var planTitleEl         = document.createElement( "span" );
    planTitleEl.setAttribute( "class", "rc-widget-title" );
    planTitleEl.appendChild( planTitleIcon );
    //planTitleEl.insertAdjacentHTML( "beforeend", sub.innerText );
    planTitleEl.insertAdjacentHTML( "beforeend", document.getElementById( "we-subscription-autoship-title" ).innerHTML );

    var planPriceEl         = document.createElement( "span" );
    planPriceEl.setAttribute( "class", "rc-widget-price-el" );

    planTitleWrapperEl.appendChild( planTitleEl );
    planTitleWrapperEl.appendChild( planPriceEl );    

    sp.appendChild( planTitleWrapperEl );
    sub.innerText = "";

    sub.appendChild( sp );
    sub.appendChild( custom.querySelector( ".rc-subscription-details" ) );


    var label = custom.querySelector( ".rc-selling-plans-dropdown__label" );
    if ( label )
    {
        label.classList.remove( "visually-hidden" );
    }

    var label = custom.querySelector( ".subscription-radio .rc-radio__label" );
    //label.insertBefore( custom.querySelector( ".subscription-radio input" ), label.firstChild );
    sp.insertBefore( custom.querySelector( ".subscription-radio input" ), sp.firstChild );
    var detail = document.createElement( "small" );
    detail.innerHTML = document.getElementById( "we-subscription-detail-container" ).innerHTML;
    leftBlock.insertBefore( detail, leftBlock.firstChild );

    var more = document.createElement( "div" );
    more.setAttribute( "class", "custom-subscription-widget-more-detail collapsed" );
    more.innerHTML = main.getAttribute( "data-sub-more-detail" );
    custom.querySelector( ".rc-radio__subscription" ).appendChild( more );

    detail = document.createElement( "small" );
    detail.innerHTML = main.getAttribute( "data-ot-detail" );

    var oneTimeLabel = custom.querySelector( ".onetime-radio .rc-radio__label" );
    oneTimeLabel.insertBefore( custom.querySelector( ".onetime-radio input" ), oneTimeLabel.firstChild );
    oneTimeLabel.appendChild( detail );

    var mainOTP  = document.querySelector( "span.component-product-price.price-large" );
    var wOTP     = custom.querySelector( ".onetime-radio .rc-radio__label" );
    var subPrice = custom.querySelector( ".subscription-radio .rc-radio__price" );
    var prices   = document.createElement( "div" );
    var otp      = document.createElement( "span" );
    otp.setAttribute( "class", "product-price--compare" );
    otp.innerHTML = ActiveCurrencyString( ParsePrice( wOTP.innerText ) );
 
    
    //subPrice.parentNode.insertBefore( prices, subPrice );
    custom.querySelector( ".subscription-radio .rc-option-title-text .rc-widget-title-wrapper .rc-widget-price-el" ).appendChild( prices );

    let hrTag = document.createElement( "hr" );
    custom.querySelector( ".rc-subscription-details" ).insertBefore(hrTag, custom.querySelector(".rc-subscription-details").firstChild);
    
    prices.setAttribute( "class", "custom-rc-prices" );
    prices.appendChild( otp );
    prices.appendChild( subPrice );

    custom.classList.add( "custom-recharge-subscription-widget" );
    custom.classList.remove( "shopify-app-block" );
    custom.removeAttribute( "id" );
    custom.removeAttribute( "style");

    custom.querySelector( ".rc-subscription-details button.rc-subscription-details__button" ).addEventListener( "click", function( e )
    {
        e.preventDefault( );
        e.stopPropagation( );

        observer.takeRecords( );
        observer.disconnect( );

        more.classList.toggle( "collapsed" );

        var buttonText = custom.querySelector( ".rc-subscription-details button.rc-subscription-details__button span" );
        if ( more.classList.contains( "collapsed" ) )
        {
            var stashed = buttonText.getAttribute( "data-stash" );
            if ( stashed )
            {
                buttonText.innerText = stashed;
            }
        }
        else
        {
            buttonText.setAttribute( "data-stash", buttonText.innerText );
            buttonText.innerHTML = main.getAttribute( "data-less" );
        }
        observer.observe( document.querySelector( ".recharge-subscription-widget" ).parentNode, { "childList": true, "subtree" : true } );
    } );

    custom.querySelector( "label.rc-radio.rc-radio--active" ).addEventListener( "click", function( e )
    {
        e.preventDefault( );
        e.stopPropagation( );
    } );

    // let autoshipAddToCartBtn = document.querySelector( ".product-form__buttons button" );
    // let autoshipAddToCartBtnText = document.querySelector( ".product-form__buttons button span" );
    
    // let activeSubscription = custom.querySelector( "label.rc-radio.rc-radio--active.subscription-radio" )
    // if (activeSubscription) {
    //     autoshipAddToCartBtn.classList.add( "autoship-add-to-cart" );
    //     autoshipAddToCartBtnText.innerHTML = `Add to <img src="https://cdn.shopify.com/s/files/1/0511/2827/1032/files/white-autoship-icon.png?v=1741615573" class="autoship-white-icon" alt="Autoship Icon"> Autoship`;
    // } else {
        
    //     autoshipAddToCartBtn.classList.remove( "autoship-add-to-cart" );
    //     autoshipAddToCartBtnText.innerHTML = "Add to Cart";
    // }

    var ids = custom.querySelectorAll( "[id]" );
    ids.forEach( function( element )
    {
        element.setAttribute( "id", "custom_" + element.getAttribute( "id" ) );
    } );

    var active = custom.querySelector( ".rc-radio--active input" );
    if ( active )
    {
        active.checked = true;
    }

    var shout = document.createElement( "div" );
    shout.setAttribute( "class", "rc-custom-shout" );
    shout.innerHTML = `<span>${main.getAttribute( "data-new" )}</span>`;
    sub.insertBefore( shout, sub.firstChild );

    var price;
    var vid            = document.querySelector( "input[name='id']" ).value;
    var activeSubPrice = custom.querySelector( ".rc-radio--active.subscription-radio .rc-radio__price" );

    if ( activeSubPrice )
    {
        price = ParsePrice( activeSubPrice.innerHTML );
    }
    else
    {
        price = Number( g_productDetail.variants[ vid ].price ) / 100;
    }

    var priceElement = document.querySelector(".component-product-price.price-large");
    if (priceElement && price !== undefined && price !== null && price !== "") {
        priceElement.innerHTML = ActiveCurrencyString(price);
    }

    var cap = Number( g_productDetail.variants[ vid ].compare_price ) / 100;
    var comparePriceElement = document.querySelector(".component-product-compare-price-amount");
    if (comparePriceElement) {
        comparePriceElement.innerHTML = ActiveCurrencyString(cap);
    }

    var pc = ((cap - price) * 100) / cap;
    var percentageElement = document.querySelector(".component-product-price-percentage");
    if (percentageElement) {
        percentageElement.innerHTML = "-" + pc.toFixed(0) + "%";
    }
    


    //var compareAtPrice = ParsePrice( wOTP.innerText );
    // if( compareAtPrice == price )
    // {
    //     otp.classList.add( "no-visibility" );
    // }
    
    widget.parentNode.insertBefore( custom, widget );
    widget.setAttribute( "style", "display: none;" );
}
function CustomRechargeUI( )
{
    if ( g_liquidLookup.autoship_enabled )
    {
        console.log( "custom recharge widget" );
        var widget = document.querySelector( ".recharge-subscription-widget" );
        var main   = document.querySelector( ".product-main" );
        if ( ( widget ) && ( main ) )
        {
            console.log( "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX   custom recharge widget XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXx" );
            var observer = new MutationObserver( function( ml, o )
            {
                var plans = widget.querySelector( ".subscription-radio" );
                if ( plans )
                {
                    observer.takeRecords( );
                    observer.disconnect( );

                    ShowCustomSubscriptionWidget( observer );
                    SetQuantitySelectorState( );
                    ObserveWidget( widget );
                }
            } );
            observer.observe( widget, { "childList": true, "subtree" : true } );
        }
    }
    else
    {
        console.log( "custom PDP ATC hancdling" );
        ObserveWidget( document.body );
    }
}

CustomRechargeUI( );


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// rebuy widget customisation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

document.addEventListener('rebuy.add', function(event)
{
    console.log('rebuy.add event', event.detail);

    jQuery.get('/?sections=cart-drawer-section',function(cart)
    {
        updateCartDrawer({sections:cart});
    } );
});

function ShowQtyControls( product, lookup )
{
    var button = product.querySelector( ".rebuy-product-actions button.rebuy-button" );
    button._has_been_swapped_for_qty_controls = true;
    button.setAttribute( "style", "display: none;" );

    if ( product._qtyControls )
    {
        product._qtyControls.remove( );
    }
    var link    = product.querySelector( "a.rebuy-product-title" ).getAttribute( "href" );
    var vid     = link.split( "?variant=" )[ 1 ];
    var wrapper = document.createElement( "div" );
    wrapper.innerHTML =
    `
      <quantity-input class="quantity quantity-wrapper" data-item-in-cart="true" data-variant-id="${vid}">
        <button class="quantity__button no-js-hidden" name="minus" type="button">
          <span class="visually-hidden">Quantity</span>
          <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"></path>
          </svg>
        </button>
        <input class="quantity__input" type="number" name="quantity"  data-cart-quantity="${lookup.qty}" data-min="1" min="1" step="1" value="${lookup.qty}">
        <button class="quantity__button no-js-hidden" name="plus" type="button">
          <span class="visually-hidden">Quantity</span>
            <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
               <path d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"></path>
            </svg>
          </span>
        </button>
      </quantity-input>
    `;

    product._qtyControls = wrapper.querySelector( "quantity-input" );
    button.parentNode.appendChild( product._qtyControls );
}

function ShowATCControls( product )
{
    var button = product.querySelector( ".rebuy-product-actions button.rebuy-button" );
    if ( button._has_been_swapped_for_qty_controls )
    {
        button._has_been_swapped_for_qty_controls = false;
        button.removeAttribute( "style" );
    }
    if ( product._qtyControls )
    {
        product._qtyControls.remove( );
        product._qtyControls = undefined;
    }
}

function SetRebuyProductStates( widget )
{
    var cartLinks    = document.querySelectorAll( ".cart-drawer__content .cart-drawer-items-container .cart-image a" );
    var productLinks = widget.querySelectorAll( ".rebuy-product-block .rebuy-product-info a.rebuy-product-title.clickable" );
    var cartLookup   = { };
    
    cartLinks.forEach( function( link )
    {
        var row        = link.closest( ".we_cart_item" );
        var qtyElement = row.querySelector( "input.cart-quantity-value" );
        var hr         = link.getAttribute( "href" );

        if ( qtyElement )
        {
            cartLookup[ hr ] = { "qty" : qtyElement.value, "link" : hr };
        }
    } );

    productLinks.forEach( function( link )
    {
        var hr      = link.getAttribute( "href" );
        var product = link.closest( ".rebuy-product-block" );
        if ( cartLookup[ hr ] )
        {
            console.log( "show qty controls for " + hr );
            ShowQtyControls( product, cartLookup[ hr ] );
        }
        else
        {
            ShowATCControls( product );
        }
    } );
}

function MonitorRebuyWidget( widget )
{
    SetRebuyProductStates( widget );
    
    var debounceTimer;
    var sidecart = document.querySelector( "#cart-drawer-wellEasy" );
    var observer = new MutationObserver( function( ml, o )
    {
        if ( debounceTimer )
        {
            clearTimeout( debounceTimer );
        }
        debounceTimer = setTimeout( function( )
        {
            debounceTimer = undefined;
            observer.takeRecords( );
            observer.disconnect( );

            SetRebuyProductStates( widget );
            
            observer.observe( sidecart, { "childList": true, "subtree" : true } );
        }, 100 );
    } );
    observer.observe( sidecart, { "childList": true, "subtree" : true } );
}

function RebuyButtonOverride( )
{
    console.log( "rebuy override" );
    
    var elements = document.querySelectorAll( ".rebuy-widget" );
    elements.forEach( function( element )
    {
        if ( element._wellEasyRebuyOverride == undefined )
        {
            element._wellEasyRebuyOverride = true;
            MonitorRebuyWidget( element );
        }
    } );
}
document.addEventListener( 'rebuy.ready', RebuyButtonOverride ); 




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// recharge portal customisation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


function CustomiseSubscriptionManagamentPortal( )
{
    var portal      = document.querySelector( "#recharge-customer-portal" );
    var tab         = portal.querySelector( ".recharge-tab" );
    var itemNames   = portal.querySelectorAll( ".recharge-component-subscription-item .recharge-heading" );
    var memberships = [ ];

    itemNames.forEach( function( name )
    {
        var row = name.closest( ".recharge-component-subscription-item" ).parentNode;
        if ( name.innerText.toLowerCase( ).indexOf( "membership" ) >= 0 )
        {
            row.classList.add( "only-on-membership-tab" );
            memberships.push( row );
        }
        else if ( !row.classList.contains( "not-on-membership-tab" ) )
        {
            row.classList.add( "not-on-membership-tab" );
        }
    } );

    if ( memberships.length > 0 )
    {
        var tabBar    = tab.closest( "[role='tablist']" );
        var memberTab = tabBar.querySelector( ".welleasy-membership-tab" );
        if ( !memberTab )
        {
            var builtInTabs = portal.querySelectorAll( ".recharge-tab" );
            builtInTabs.forEach( function( bit )
            {
                bit.setAttribute( "data-welleasy-override", "enabled" );
                bit.__WEWTF = "listener added";
                bit.addEventListener( "click", function( e )
                {
                    console.log( "built in tab clicked", e );
                    portal.classList.remove( "membership-tab-active" );
                } );
            } );
            
            var inactiveTab = tabBar.querySelector( ".recharge-tab:not(.recharge-tab-active)" ).parentNode;
            memberTab = inactiveTab.cloneNode( true );
            var content = memberTab.firstChild;
            content.setAttribute( "id", content.getAttribute( "id" ) + "_membershiptab" );
            content.querySelector( ".recharge-text" ).innerText = "Membership";

            memberTab.classList.add( "welleasy-membership-tab" );
            tabBar.firstChild.appendChild( memberTab );

            memberTab.addEventListener( "click", function( )
            {
                portal.classList.add( "membership-tab-active" );
            } );
        }
    }
    else
    {
        var tabBar    = tab.closest( "[role='tablist']" );
        var memberTab = tabBar.querySelector( ".welleasy-membership-tab" );
        if ( memberTab )
        {
            memberTab.remove( );
            portal.classList.remove( "membership-tab-active" );
        }
    }


    var header = portal.querySelector( ".welleasy-autoship-header" );
    if ( header )
    {
        header.remove( );
        portal.querySelector( ".welleasy-autoship-content" ).remove( );
    }
}

function IsInDOM( root, element )
{
    if ( element == root )
    {
        return ( true );
    }
    else if ( element )
    {
        return ( IsInDOM( root, element.parentNode ) );
    }
    else
    {
        return ( false );
    }
}

function FirstCommonAncestor( a, b )
{
    if ( IsInDOM( a, b ) )
    {
        return ( a );
    }
    else if ( a )
    {
        return ( FirstCommonAncestor( a.parentNode, b ) );
    }
    else
    {
        return ( null );
    }
}

function CustomiseOrderManagamentPortal( )
{
    var found           = document.querySelectorAll( ".recharge-section-next-order-list span[role='heading']:not(.already-checked)" );
    var productCount    = 0;
    var membershipCount = 0;
    for ( var i = 0; i < found.length; i++ )
    {
        var element = found[ i ];
        if ( element.innerText.toLowerCase( ).indexOf( "deliver to" ) >= 0 )
        {
            // ignore
        }        
        else if ( element.innerText.toLowerCase( ).indexOf( "membership" ) >= 0 )
        {
            membershipCount++;
        }
        else if ( element.innerText.toLowerCase( ).indexOf( "order total" ) >= 0 )
        {
            break;
        }
        else
        {
            productCount++;
        }
    }
    
    if ( ( membershipCount > 0 ) && ( productCount == 0 ) )
    {
        var msg = document.querySelector( ".welleasy-autoship-cs-message" );
        var order = document.querySelector( ".recharge-section-next-order-list" );
        order.parentNode.insertBefore( msg, order.nextSibling );
        msg.classList.remove( "hidden" );
    }
    
    
    var missing = document.querySelectorAll( ".recharge-section-upcoming-products *:nth-child(2) span[role='heading']:not(.already-checked)" );
    if ( ( missing ) && ( missing.length > 0 ) )
    {
        var memberships = [ ];
        missing.forEach( function( heading )
        {
            if ( heading.innerText.toLowerCase( ).indexOf( "membership" ) >= 0 )
            {
                memberships.push( heading );
                heading.classList.add( "already-checked" );
            }
        } );

        if ( ( memberships.length == 1 ) && ( missing.length == 1 ) )
        {
            // simple case: all products except membership are in the order
            document.querySelector( ".recharge-section-upcoming-products" ).setAttribute( "style", "display: none;" );
        }
        else if ( ( memberships.length > 0 ) && ( missing.length > 1 ) )
        {
            // got to hide just the membership product(s)
            var fca = FirstCommonAncestor( missing[ 0 ], missing[ 1 ] );
            var kid = fca.firstChild;
            var del = 0;
            while ( kid )
            {
                memberships.forEach( function( heading )
                {
                    if ( IsInDOM( kid, heading ) )
                    {
                        kid.setAttribute( "style", "display: none;" );
                        del++;
                    }
                } );
                kid = kid.nextSibling;
            }
            if ( del > 0 )
            {
                var heading = document.querySelector( ".recharge-section-upcoming-products .recharge-heading" );
                if ( heading )
                {
                    var txt = heading.innerText;
                    var space = txt.indexOf( " " );
                    if ( space > 0 )
                    {
                        var val = Number( txt.substr( 0, space ) );
                        if ( !( isNaN( val ) ) )
                        {
                            val -= del;
                            heading.innerText = val + txt.substr( space );
                        }
                    }
                }
            }
        }
    }
}

function RemoveAutoshipCustomisations( )
{
    var portal = document.querySelector( "#recharge-customer-portal" );
    var header = portal.querySelector( ".welleasy-autoship-header" );
    if ( header )
    {
        header.remove( );
        portal.querySelector( ".welleasy-autoship-faq" ).remove( );
        portal.querySelector( ".welleasy-autoship-content" ).remove( );
    }
}

function ToggleFAQOpen( e )
{
    var button = e.currentTarget;
    var item   = button.closest( ".welleasy-autoship-faq-item" );
    item.classList.toggle( "welleasy-faq-content-visible" );
}

function ShowAutoshipHeader( )
{
    var portal = document.querySelector( "#recharge-customer-portal" );
    var header = portal.querySelector( ".welleasy-autoship-header" );
    if ( !header )
    {
        header = document.createElement( "div" );
        header.innerHTML =
        `
            <div class="welleasy-autoship-header">
              <div class="welleasy-autoship-feedback-prompt">
                  <a href="${g_liquidLookup.recharge_portal_feedback_link}">${g_liquidLookup.recharge_portal_feedback_text}</a>
                  <img src="${g_liquidLookup.recharge_portal_feedback_icon}" >
              </div>
              <div class="welleasy-autoship-header-inner">
                <h1>${g_liquidLookup.recharge_portal_header_title}</h1>
                <p>${g_liquidLookup.recharge_portal_header_text}</p>
                <a href="https://welleasysupport.zendesk.com/hc/en-us" class="welleasy-autoship-contact-button">${g_liquidLookup.recharge_portal_contact_text}</a>
              </div>
            </div>
            <div class="welleasy-autoship-content">
               <p class="welleasy-autoship-new">${g_liquidLookup.recharge_portal_new}</p>
               <div class="welleasy-autoship-content-row">
                   <h2 class="autoship-banner-header">
                   <img src="${g_liquidLookup.recharge_portal_autoship_icon}" alt="${g_liquidLookup.recharge_portal_autoship_icon_alt}" class="autoship-banner-icon">
                   ${g_liquidLookup.recharge_portal_content_title}</h2>
               </div>
               <p>${g_liquidLookup.recharge_portal_content_text}</p>
               <a href="#welleasy-autoship-faq" class="welleasy-autoship-learn-more">${g_liquidLookup.recharge_portal_content_learn_more}</a>
            </div>
        `;
        portal.insertBefore( header, portal.firstChild );
    }

    var faq = portal.querySelector( "#welleasy-autoship-faq" );
    if ( !faq )
    {
        faq = document.createElement( "div" );
        faq.setAttribute( "class", "welleasy-autoship-content welleasy-autoship-faq" );
        faq.setAttribute( "id", "welleasy-autoship-faq" );

        var defs = JSON.parse( g_liquidLookup.autoship_faq_json );
        faq.innerHTML = `<div class="welleasy-autoship-cs-message welleasy-autoship-content hidden"><p>${g_liquidLookup.recharge_portal_cs_message}</p></div><h2 class="autoship-banner-header">${defs.title}</h1><p>${defs.headline}</p>`;

        defs.faq.forEach( function( item )
        {
            var element = document.createElement( "div" );
            element.setAttribute( "class", "welleasy-autoship-faq-item" );
            element.innerHTML =
            `
                <div class="welleasy-autoship-content-row">                
                  <div class="welleasy-autoship-faq-item-header">                
                    <h3>${item.title}</h3>
                    <span>></span>
                  </div>
                  <div class="welleasy-faq-content">
                    <p>${item.detail}</p>
                  </div>
                </div>
            `;
            element.querySelector( "span" ).addEventListener( "click", ToggleFAQOpen );
            faq.appendChild( element );
        } );
        
        portal.appendChild( faq );
    }
}

function StartupRechargePortalCustomisations( )
{
    if ( g_liquidLookup.autoship_enabled )
    {
        console.log( "starting portal customisations" );
        if ( window.location.pathname.indexOf( "/tools/recurring/portal/" ) >= 0 )
        {
            var portal = document.querySelector( "#recharge-customer-portal" );
            if ( portal )
            {
                var observer = new MutationObserver( function( ml, o )
                {
                    if ( window.location.pathname.indexOf( "subscriptions" ) > 0 )
                    {
                        var tab = portal.querySelector( ".recharge-tab" );
                        if ( tab )
                        {
                            observer.takeRecords( );
                            observer.disconnect( );

                            CustomiseSubscriptionManagamentPortal( );

                            observer.observe( portal, { "childList": true, "subtree" : true } );
                        }
                    }
                    else if ( window.location.pathname.indexOf( "overview" ) > 0 )
                    {
                        ShowAutoshipHeader( );

                        var element = portal.querySelector( ".recharge-section-upcoming-products" );
                        if ( element )
                        {
                            observer.takeRecords( );
                            observer.disconnect( );

                            CustomiseOrderManagamentPortal( );

                            observer.observe( portal, { "childList": true, "subtree" : true } );
                        }
                    }
                    else
                    {
                        RemoveAutoshipCustomisations( );
                    }
                } );
                observer.observe( portal, { "childList": true, "subtree" : true } );
            }
        }
    }
}

StartupRechargePortalCustomisations( );


// product page info

function StartupProductPageInfoHandling( )
{
    var info = document.querySelector( ".component-product-compare-price-info" );
    if ( info )
    {
        info.addEventListener( "click", function( e )
        {
            document.querySelector( ".component-product-compare-price-info-content" ).classList.remove( "collapsed" );
        } );
    }
    var close = document.querySelector( ".component-product-compare-price-info-close" );
    if ( close )
    {
        close.addEventListener( "click", function( e )
        {
            document.querySelector( ".component-product-compare-price-info-content" ).classList.add( "collapsed" );
        } );
    }
}
StartupProductPageInfoHandling( );
